import React from 'react';
import { TeContainerSlim, TeIcon, TeText, TeToggle } from '@topcon/tuicl-react';
import styled from 'styled-components';
import { paddingToPixelString } from '@topcon/tuicl/dist/common/utils';

import { border } from '../../../providers/theme/theme.index';

const IconWrapper = styled.div`
  padding: ${paddingToPixelString('s')};
  border-right: 1px solid ${border.secondary};
`;

const NotificationTypeCard = ({
  label,
  sublabel,
  iconName,
  disabled,
  iconOutline,
  checked,
  onCheckedChange,
}: {
  label: string;
  iconName: string;
  disabled?: boolean;
  iconOutline?: boolean;
  sublabel?: string;
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
}) => {
  return (
    <TeContainerSlim fill borderRadius="l" borderColor="border.secondary">
      <IconWrapper>
        <TeIcon
          name={iconName}
          size="l"
          outline={iconOutline}
          color={disabled ? 'background.disabled' : 'text.primary'}
        />
      </IconWrapper>
      <TeContainerSlim
        fill
        grow
        alignItems="center"
        justifyContent="space-between"
        padding="s"
        style={{ maxHeight: '48px' }}
      >
        <TeContainerSlim fill grow column justifyContent="space-between">
          <TeText
            size="m"
            weight="normal"
            color={disabled ? 'background.disabled' : 'text.primary'}
          >
            {label}
          </TeText>
          {sublabel && (
            <TeText size="s" color="text.secondary">
              {sublabel}
            </TeText>
          )}
        </TeContainerSlim>
        <TeToggle
          size="s"
          toggled={checked}
          disabled={disabled}
          techange={(e) => {
            onCheckedChange(e.target.checked);
          }}
        />
      </TeContainerSlim>
    </TeContainerSlim>
  );
};

export default NotificationTypeCard;
